import { ADALONG_COLORS } from '@src/styles';

// Shared style constants for table components
export const TABLE_STYLES = {
  tableClass: {
    width: '100%',
    borderCollapse: 'collapse' as const,
    marginTop: 4,
    marginBottom: 4,
    fontSize: 14,
    background: 'transparent',
    color: 'white',
  },

  headerRowClass: {
    borderBottom: '2px solid #444',
    background: 'transparent',
  },

  thClass: {
    fontWeight: 600,
    fontSize: 15,
    color: 'white',
    textAlign: 'left' as const,
    padding: '14px 8px',
    background: 'transparent',
  },

  headerWithFilterClass: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    minHeight: 20,
  },

  rowClass: {
    borderBottom: '1px solid #333',
    height: 54,
    cursor: 'pointer',
  },

  tdClass: {
    padding: '8px',
    fontSize: 14,
    verticalAlign: 'middle' as const,
    height: 54,
    maxWidth: 150,
    overflow: 'hidden' as const,
    textOverflow: 'ellipsis' as const,
    whiteSpace: 'nowrap' as const,
  },

  sortIconClass: {
    fontSize: '12px',
    cursor: 'pointer',
  },

  sortIconInactiveStyle: {
    fontSize: '14px',
    color: '#888',
    cursor: 'pointer',
  },

  scrollContainerStyle: {
    height: '60vh',
    maxHeight: '500px',
    backgroundColor: 'transparent',
    position: 'relative' as const,
    overflow: 'hidden' as const,
  },

  scrollContentStyle: {
    minHeight: '100%',
    paddingRight: '17px',
  },

  sortControlsStyle: {
    display: 'flex',
    alignItems: 'center',
  },

  emptyRowStyle: {
    textAlign: 'center' as const,
    color: '#888',
    padding: '20px',
  },

  loadingContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },

  loadMoreRowStyle: {
    textAlign: 'center' as const,
    padding: '12px 8px',
    color: ADALONG_COLORS.LIGHT_GRAY,
  },

  emptyStateContainerStyle: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: '8px',
  },

  emptyStateTitleStyle: {
    fontSize: '16px',
    fontWeight: 600,
    color: ADALONG_COLORS.SMOOTH_WHITE,
  },

  emptyStateDescriptionStyle: {
    fontSize: '14px',
    color: ADALONG_COLORS.LIGHT_GRAY,
    textAlign: 'center' as const,
  },

  messageContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  messageTextStyle: {
    overflow: 'hidden' as const,
    textOverflow: 'ellipsis' as const,
    whiteSpace: 'nowrap' as const,
  },

  languageBadgeStyle: {
    backgroundColor: '#333',
    color: 'white', // This will be overridden by dynamic styles
    padding: '2px 6px',
    borderRadius: '4px',
    fontSize: '12px',
  },
};

// Shared utility functions
export const getRowClass = (rowId: string, selectedRowId?: string | null, hasUnread?: boolean) => ({
  ...TABLE_STYLES.rowClass,
  backgroundColor: selectedRowId === rowId ? ADALONG_COLORS.LIGHT_BLACK : 'transparent',
  fontWeight: hasUnread ? 'bold' : 'normal',
});

export const getTdClassWithColor = (
  conversationType: 'stored' | 'remote' | 'merged',
  hasUnread?: boolean,
) => ({
  ...TABLE_STYLES.tdClass,
  color: conversationType === 'stored' ? ADALONG_COLORS.LIGHT_GRAY : ADALONG_COLORS.SMOOTH_WHITE,
  fontWeight: hasUnread ? 'bold' : 'normal',
});

export const unreadDotStyle = (isUnread: boolean, isStored: boolean) => ({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: isUnread ? ADALONG_COLORS.FLASH_BLUE : '#FF9800',
  flexShrink: 0,
});

// Updated to respect conversation type for proper coloring
export const getLanguageBadgeStyle = (conversationType: 'stored' | 'remote' | 'merged') => ({
  ...TABLE_STYLES.languageBadgeStyle,
  color: conversationType === 'stored' ? ADALONG_COLORS.LIGHT_GRAY : 'white',
});

export const getMessageTextStyle = (conversationType: 'stored' | 'remote' | 'merged') => ({
  ...TABLE_STYLES.messageTextStyle,
  color: conversationType === 'stored' ? ADALONG_COLORS.LIGHT_GRAY : ADALONG_COLORS.SMOOTH_WHITE,
});

export const getDiffusionTextStyle = (
  count: number,
  conversationType: 'stored' | 'remote' | 'merged',
) => ({
  color:
    conversationType === 'stored'
      ? ADALONG_COLORS.LIGHT_GRAY
      : count > 0
      ? ADALONG_COLORS.SMOOTH_WHITE
      : ADALONG_COLORS.LIGHT_GRAY,
});

export const getCheckboxStyle = (conversationType: 'stored' | 'remote' | 'merged') => ({
  color: conversationType === 'stored' ? ADALONG_COLORS.LIGHT_GRAY : ADALONG_COLORS.SMOOTH_WHITE,
  '&.Mui-checked': {
    color: conversationType === 'stored' ? ADALONG_COLORS.LIGHT_GRAY : ADALONG_COLORS.SMOOTH_WHITE,
  },
  '& .MuiSvgIcon-root': {
    color: conversationType === 'stored' ? ADALONG_COLORS.LIGHT_GRAY : ADALONG_COLORS.SMOOTH_WHITE,
  },
});
